module.exports = __webpack_public_path__ + "assets/img/Deauville_010.6473754c.jpg";